// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__r-gq5","inputWrap":"Table_inputWrap__1_cNl","col":"Table_col__Ea0uo","bmiTooltip":"Table_bmiTooltip__1Aaw7"};